import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { NotebookText, FileText, X, CalendarDays } from "lucide-react";

/* Resumo da reunião para quem faltou — com material e próximas datas. */
export default function MeetingSummaryNotice() {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/convocations/mine/summary").then((r) => setS(r.data.summary)).catch(() => {});
  }, []);

  if (!s) return null;

  const dismiss = async () => {
    setS(null);
    try { await api.post(`/convocations/${s.id}/summary/dismiss`); } catch { /* volta a aparecer na próxima visita */ }
  };

  return (
    <div className="kw-card p-5 border-l-2 border-[#EAB308] kw-fade-up" data-testid="meeting-summary-notice">
      <div className="flex items-start gap-4">
        <NotebookText className="w-5 h-5 text-[#EAB308] mt-1 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="kw-overline text-[#EAB308]">Resumo · {s.was_present ? "obrigado por teres estado" : "sentimos a tua falta"}</div>
          <div className="font-display text-xl font-black uppercase tracking-tight">{s.title}</div>
          <div className="text-sm text-[#A3A3A3] mt-3 whitespace-pre-line leading-relaxed max-w-3xl"
            data-testid="meeting-summary-text">{s.text}</div>
          {s.material_url && (
            <a href={s.material_url} target="_blank" rel="noopener noreferrer"
              className="mt-4 text-[10px] uppercase tracking-widest font-bold px-3 py-2 border border-[#333] text-[#A3A3A3] hover:text-white inline-flex items-center gap-1.5 transition-colors"
              data-testid="meeting-summary-material">
              <FileText className="w-3 h-3" /> Material da reunião
            </a>
          )}
          {s.next_dates?.length > 0 && (
            <div className="mt-4" data-testid="meeting-summary-next">
              <div className="kw-overline mb-2">Próximas datas</div>
              {s.next_dates.map((d) => (
                <div key={d.id} className="text-xs text-[#A3A3A3] flex items-center gap-2 py-0.5">
                  <CalendarDays className="w-3 h-3 text-[#E50000] shrink-0" />
                  <b className="text-white">{d.title}</b> · {d.when_label} · {d.location}
                </div>
              ))}
            </div>
          )}
        </div>
        <button onClick={dismiss} className="text-[#555] hover:text-white p-1 shrink-0" title="Já li"
          data-testid="meeting-summary-dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
